import React, { useEffect, useState } from "react";
import moment from "moment";
import { DATETIME_FORMATZ_FOR_API } from "../../../constants/constants";
import { VaporDatePicker } from "../../vapor";
import { FormattedMessage } from "react-intl";

const Date = ({frequencyDates, setFrequencyDates, frequencyType, isSave, requestBody, setRequestBody}) => {
  const [dateError, setDateError] = useState(false);

  useEffect(() => {   
    if (!isSave) setDateError(false); 
    else setDateError((frequencyType === "single" && !requestBody.date) || 
      (frequencyType === "recurring" && 
        (!frequencyDates.startDate || !frequencyDates.endDate)));
  }, [isSave]);
  
  return (
    <div data-testid="container"       
      className={`pickerContainer ${dateError ? "errorOccurs" : ""}`}>   
      <div style={{display:"flex", flexDirection: "column",
        width: frequencyType === "recurring" ? "48%" : "100%", 
        marginRight: "38px" }}>
        <div className="labelDialogContent" style={{marginTop: 0}}>          
          <FormattedMessage id={frequencyType === "single" ? 
            "deadlines.deadlineDateColumn" : "deadlines.pages.create.startDate"} />
        </div>       
        <VaporDatePicker  
          getPopupContainer={trigger => trigger.parentNode}
          data-testid="start-date"        
          allowClear={true}
          // dropdownClassName="modalOverlay"
          onChange={(date) => {
            frequencyType === "recurring" ?
              setFrequencyDates({
                ...frequencyDates,
                date: undefined,
                startDate: !date ? null : moment(`${date}`).format(DATETIME_FORMATZ_FOR_API)
              }) :
              setRequestBody({
                ...requestBody,
                date: !date ? null : moment(`${date}`).format(DATETIME_FORMATZ_FOR_API),
                startDate: undefined
              });
         
          }}
          value={frequencyType === "recurring" ? 
            frequencyDates.startDate ? moment(frequencyDates.startDate) : null
            : 
            requestBody.date ? moment(requestBody.date) : null
          }
          placeholder={"gg/mm/aaaa"}        
        />    
      </div>  
      {
        frequencyType === "recurring" && 
        <div style={{display:"flex", flexDirection: "column",
          width: frequencyType === "recurring" ? "48%" : "100%", 
          marginRight: "38px" }}>
          <div className="labelDialogContent" style={{marginTop: 0}}>          
            <FormattedMessage id={"deadlines.pages.create.finalDate"} />
          </div>      
          <VaporDatePicker  
            getPopupContainer={(trigger) => trigger.parentNode}
            data-testid="end-date"                  
            allowClear={true}
            // dropdownClassName="modalOverlay"
            onChange={(date) => {              
              setFrequencyDates({
                ...frequencyDates,
                endDate: date === null ? null : moment(`${date}`).format(DATETIME_FORMATZ_FOR_API)
              });
            }}
            value={ frequencyDates.endDate ? moment(frequencyDates.endDate) : null }
            placeholder={"gg/mm/aaaa"}        
          />
        </div>
      }
    </div>
  );
};

export default Date;